import React from 'react'
import addCardPopupData from './data'
import { CircularProgress, Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { editSectionOrderAction } from 'src/reducers/course/action'
import { useDispatch, useSelector } from 'react-redux'
import { messageBoxHideAction } from 'src/reducers/message-box/action'
import { useHistory, useLocation } from 'react-router-dom'
import clsx from 'clsx'
import { getCardAction } from 'src/reducers/card/action'
import AiQuizPopup from 'src/components/ai-quiz-popup'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import {
  generateCardAction,
  setCardCreationProgress,
} from 'src/reducers/course/action'
import { getCourseCreationProgressAction } from 'src/reducers/course/action'
import { courseGetAction } from 'src/reducers/course/action'
const contentType = {
  info: 0,
  quiz: 1,
}

const sourceType = {
  AI: 0,
  UploadedDocument: 1,
  CourseContent: 2,
}

const SelectionPopup = props => {
  const { classes, section, sections, setSections, fromMidPage } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const course = useSelector(state => state.course.course)
  const card = useSelector(state => state.card.currentCard)
  const [createdCardId, setCreatedCardId] = React.useState(null)
  const cardCreationProgress = useSelector(
    state => state.course.cardCreationProgress,
  )
  const [loading, setLoading] = React.useState(false)
  // Transform sections into options for AutoComplete
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const cardId = searchParams.get('page')

  const sectionOptions = [
    { name: 'All sections', value: 'allsections' },
    ...sections.map(section => ({
      name: section.name,
      value: section.id,
    })),
  ]
  const handleAddCard = type => {
    if (type === 'page-change') {
      openGenerateQuiz()
      return
    }

    setLoading(true)
    let newSections = [...sections]
    const targetSection = newSections.find(item => item.id === section.id)

    const newCard = {
      type: type,
      title: '',
      sectionId: section.id,
      id: null,
    }

    if (fromMidPage && card) {
      // Find the index of the current card
      const currentCardIndex = targetSection.cards.findIndex(
        c => c.id === card.id,
      )
      if (currentCardIndex !== -1) {
        // Insert the new card after the current card
        targetSection.cards.splice(currentCardIndex + 1, 0, newCard)
      } else {
        // Fallback to pushing at the end if current card not found
        targetSection.cards.push(newCard)
      }
    } else {
      // Original behavior: add to the end
      targetSection.cards.push(newCard)
    }

    // Recalculate global card order
    let globalCardOrder = 0
    newSections = newSections.map(section => ({
      ...section,
      cards: section.cards.map(card => ({
        ...card,
        orderOfCard: globalCardOrder++,
      })),
    }))

    if (window.lintrk) {
      window.lintrk('track', { conversion_id: 21804609 })
    }

    dispatch(
      editSectionOrderAction(course.id, { sections: newSections }, response => {
        let stateSections = [...newSections]
        const targetStateSection = stateSections.find(
          item => item.id === section.id,
        )

        // Find the newly added card (the one with null id) and update its id
        const newlyAddedCard = targetStateSection.cards.find(
          item => item.id === null,
        )
        if (newlyAddedCard) {
          newlyAddedCard.id = response.sections[0].cards[0].id
        }

        setSections(stateSections)
        history.push(
          `/mini-course/${course.id}/page/${response.sections[0].cards[0].id}`,
        )
        dispatch(getCardAction(response.sections[0].cards[0].id))
        setLoading(false)
        dispatch(messageBoxHideAction())
      }),
    )
  }

  const handleAddQuiz = quizData => {
    let startOrder = 0
    if (fromMidPage && card) {
      const currentCardIndex = sections
        .find(s => s.id === section.id)
        .cards.findIndex(c => c.id === card.id)
      if (
        currentCardIndex !== -1 &&
        currentCardIndex !==
          sections.find(s => s.id === section.id).cards.length - 1
      ) {
        startOrder =
          sections.find(s => s.id === section.id).cards[currentCardIndex + 1]
            .orderOfCard + 1
      } else {
        startOrder =
          sections.find(s => s.id === section.id).cards[
            sections.find(s => s.id === section.id).cards.length - 1
          ].orderOfCard + 1
      }
    } else {
      startOrder =
        sections.find(s => s.id === section.id).cards[
          sections.find(s => s.id === section.id).cards.length - 1
        ].orderOfCard + 1
    }

    const startingOrder =
      fromMidPage && card ? card.orderOfCard + 1 : startOrder || 0
    const data = {
      courseId: course.id,
      sectionId: section.id,
      startingOrder: startingOrder,
      count: quizData.questionCount,
      contentType: contentType.quiz,
      sourceType:
        quizData.resourceType === 'course'
          ? sourceType['CourseContent']
          : quizData.resourceType === 'pdf'
          ? sourceType['UploadedDocument']
          : sourceType['AI'],
      attachments:
        quizData.resourceType === 'pdf'
          ? [
              {
                attachment_id: quizData.attachments.attachment_id,
                titles: [
                  {
                    element_id: quizData.attachments.element_id,
                    title: quizData.attachments.displayTitle,
                  },
                ],
              },
            ]
          : null,
      prompt: quizData.description,
      sourceSections:
        quizData.resourceType === 'course'
          ? quizData.section.value === 'allsections'
            ? null
            : [quizData.section.value]
          : null,
    }
    dispatch(
      generateCardAction(data, response => {
        if (response && response[0]) {
          const cardId = response[0].cardId
          if (cardId) {
            setCreatedCardId(cardId)
            dispatch(setCardCreationProgress(true))
            let checkProgressInterval = setInterval(() => {
              checkProgress(course.id, cardId, checkProgressInterval)
            }, 1000)
          }
        }
      }),
    )
  }

  const checkProgress = (courseId, generatedCardId, interval) => {
    dispatch(
      getCourseCreationProgressAction(courseId, response => {
        if (response.cardCreationProgress >= 100) {
          dispatch(
            courseGetAction(courseId, () => {
              history.push(`/mini-course/${courseId}/page/${generatedCardId}`)
              clearInterval(interval)
              dispatch(setCardCreationProgress(false))
              dispatch(messageBoxHideAction())
            }),
          )
        }
      }),
    )
  }

  const openGenerateQuiz = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          hideCloseButton: true,
          maxWidth: '780px',
          title: `
            <div 
              style="
              display: flex;
              align-items: center;
              gap: 8px;
            "
            >
              <img
                src="/assets/card-type-images/add-card-popup/ai-quiz.svg"
                alt="ai-quiz"
                style="
                  width: 24px;
                  height: 24px;
                "
              />
              <Typography 
                fontSize="16px"
                fontWeight=400
              >
                AI-powered Quiz
              </Typography>
            </div>
            `,
          component: (
            <AiQuizPopup
              sectionOptions={sectionOptions}
              onSubmit={handleAddQuiz}
              cardCreationProgress={cardCreationProgress}
            />
          ),
        }),
      ),
    )
  }

  return (
    <div
      className={clsx({
        [classes.container]: !loading,
        [classes.loadingContainer]: loading,
      })}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        addCardPopupData.map((item, index) => {
          return (
            <div
              key={index}
              className={classes.cardWrapper}
              onClick={() => handleAddCard(item.type)}
            >
              <div className={classes.headerDiv}>
                <Typography className={classes.headerText}>
                  {item.header}
                </Typography>
              </div>
              <img
                src={item.image}
                alt={item.title}
                className={classes.image}
              />
              <Typography
                className={classes.title}
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
            </div>
          )
        })
      )}
    </div>
  )
}

export default withStyles(styles)(SelectionPopup)
